import { graphql } from "gatsby";
import React from "react";
import PostMeta from "../components/_legacy/PostMeta";
import ArticleContent from "../components/articleContent/ArticleContent";
import Grid, { Col } from "../components/grid/Grid";
import Meta from "../components/meta/Meta";
import Section from "../components/section/Section";
import PageLabel from "../components/pageLabel/PageLabel";
import { kebabCase } from "../utils/kebabCase";
import * as styles from "./post.module.css";

const Post = ({ data }) => {
  const {
    title,
    splitTitle,
    splitSubtitle,
    content,
    author,
    authors,
    publishedDate,
  } = data.contentfulPost;

  return (
    <article>
      <Section
        header
        padding="bottom"
      >
        <Grid>
          <Col span={6} start={4}>
            <PageLabel to="/blog/">Insights</PageLabel>
            <div className={styles.titles}>
              {!splitTitle && <h1 className="noMargin">{title}</h1>}
              {splitTitle && (
                <h1 className="noMargin">
                  {splitTitle}
                  {splitSubtitle && (
                    <>
                      <br />
                      <div className={`h3 ${styles.subtitle} noBottomMargin`}>
                        {splitSubtitle}
                      </div>
                    </>
                  )}
                </h1>
              )}
            </div>
          </Col>
        </Grid>
        <Grid>
          <Col span={6} start={4}>
            {author && !authors && <PostMeta author={author} timeToRead={content.childMarkdownRemark.timeToRead} publishedDate={publishedDate} position={author.position} />}
            {authors && (
              <div className={styles.multipleAuthors}>
                {authors.map((author) => (
                  <PostMeta key={author.name} author={author} />
                ))}
              </div>
            )}
          </Col>
        </Grid>
        <Grid className="textMarginTopLarge">
          <Col span={6} start={4}>
            <ArticleContent content={content?.childMarkdownRemark.html} />
          </Col>
        </Grid>
      </Section>
    </article>
  );
};

export default Post;

export const Head = ({ data }) => {
  const {
    title,
    seoTitle,
    seoDescription,
    seoKeywords,
    image,
    description,
    content,
    author,
    private: setToPrivate,
  } = data.contentfulPost;

  return (
    <>
      <Meta
        type="blogPost"
        title={`${seoTitle || title} | ustwo Insights`}
        description={seoDescription || description}
        keywords={seoKeywords}
        imageUrl={image?.file.url}
        url={`https://ustwo.com/blog/${kebabCase(title)}`}
        author={author && author.name}
        timeToRead={content.childMarkdownRemark.timeToRead}
      />
      {setToPrivate && <meta name="robots" content="noindex" />}
    </>
  );
}

export const query = graphql`
  query($title: String) {
    contentfulPost(title: { eq: $title }) {
      __typename
      title
      splitTitle
      splitSubtitle
      description
      publishedDate
      content {
        childMarkdownRemark {
          html
          timeToRead
        }
      }
      author {
        name
        photo {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          title
        }
        noProfile
        position
      }
      authors {
        name
        photo {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          title
        }
        noProfile
      }
      image {
        file {
          url
        }
      }
      seoTitle
      seoDescription
      seoKeywords
      private
    }
  }
`;
